module.exports = __webpack_public_path__ + "img/otherProduct.3216366f.png";